/**
 * Access-token storage — IN MEMORY ONLY (E1 = B-cookie).
 *
 * The access token lives in this module variable and nowhere else: never
 * localStorage, never sessionStorage, never a cookie we set. It is short-lived
 * (15 min) and re-mintable from the refresh path. The 30-day refresh token is
 * an httpOnly cookie set by raad-api and is never visible to this code at all.
 *
 * A reload wipes this variable; the SPA silently re-mints on boot by POSTing
 * /auth/refresh (the cookie rides along) — see authClient.bootstrap.
 */

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}

// Forced-logout bus: apiClient fires this when a refresh fails (expiry,
// revocation, or reuse-burn — indistinguishable by design). AuthProvider
// subscribes to flip the app to the login screen and clear cached data.
type Listener = () => void;
const listeners = new Set<Listener>();

export function onForcedLogout(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitForcedLogout(): void {
  clearAccessToken();
  for (const fn of listeners) fn();
}
